/**
 * AM.One API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Deterministic safe projection for FAILED: code INDEXING_FAILED, message \"Indexing failed.\", and retryable false. Null for every other state. 
 */
export interface ProjectIndexingPublicError { 
    code: ProjectIndexingPublicError.CodeEnum;
    /**
     * Safe user-facing message without implementation details.
     */
    message: ProjectIndexingPublicError.MessageEnum;
    retryable: ProjectIndexingPublicError.RetryableEnum;
}
export namespace ProjectIndexingPublicError {
    export const CodeEnum = {
        IndexingFailed: 'INDEXING_FAILED'
    } as const;
    export type CodeEnum = typeof CodeEnum[keyof typeof CodeEnum];
    export const MessageEnum = {
        IndexingFailed: 'Indexing failed.'
    } as const;
    export type MessageEnum = typeof MessageEnum[keyof typeof MessageEnum];
    export const RetryableEnum = {
        False: false
    } as const;
    export type RetryableEnum = typeof RetryableEnum[keyof typeof RetryableEnum];
}


